export const STORY_DETAILS_LAUNCHED = 'ViewerPage/STORY_DETAILS_LAUNCHED';
export const STORY_DETAILS_SUCCESS = 'ViewerPage/STORY_DETAILS_SUCCESS';
export const STORY_DETAILS_FAILURE = 'ViewerPage/STORY_DETAILS_FAILURE';
